import * as React from "react";

export const BankIcon = (props) => (
    <svg
        width={30}
        height={30}
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M21.648 12.944h5.53v9.73h-5.53zm-9.414 0h5.53v9.73h-5.53zm16.001 11.488H1.765C.792 24.432 0 25.221 0 26.19v2.052C0 29.212.792 30 1.765 30h26.47c.973 0 1.765-.789 1.765-1.758V26.19c0-.97-.792-1.758-1.765-1.758m.659-18.912L15.656.126a1.76 1.76 0 0 0-1.318.003L1.106 5.519A1.75 1.75 0 0 0 0 7.152v2.277c0 .97.792 1.758 1.765 1.758h26.47c.973 0 1.765-.789 1.765-1.758V7.15a1.75 1.75 0 0 0-1.106-1.631M15.882 6.556a.88.88 0 0 1-.882.879.88.88 0 0 1-.882-.88V4.68A.88.88 0 0 1 15 3.801a.88.88 0 0 1 .882.88zM2.824 12.944h5.53v9.73h-5.53z"
            fill="currentColor"
        />
    </svg>
);

